import React from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineSupervisorAccount, MdOutlineAdminPanelSettings } from "react-icons/md";
import { FaArrowRight, FaShieldAlt } from "react-icons/fa";
import "../styles/Login.css";
import Logo from "../assets/images/TCUK-Logo.png";
import HeaderLogo from "../components/HeaderLogo.jsx";

export default function PortalSelectPage() {
  const navigate = useNavigate();

  return (
    <div className="auth-page-wrapper">
      <HeaderLogo title="TOPCOIN UK" />

      <div className="portal-select-card">
        <div className="portal-logo-glow-wrap">
          <img src={Logo} alt="TopCoin UK" className="portal-brand-logo" />
        </div>

        <h2 className="portal-select-title">Welcome to TopCoin UK</h2>
        <p className="portal-select-subtitle">
          Select your administrative portal to sign in
        </p>

        <div className="portal-cards-grid">
          {/* Option 1: Super Admin */}
          <div
            className="portal-choice-card card-superadmin"
            onClick={() => navigate("/superadmin/login")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/superadmin/login")}
          >
            <div className="portal-choice-header">
              <span className="portal-choice-badge badge-superadmin">Super Admin Portal</span>
            </div>

            <div className="portal-choice-icon-wrap icon-superadmin">
              <MdOutlineSupervisorAccount size={36} />
            </div>

            <h3 className="portal-choice-name">Super Admin</h3>
            {/* <p className="portal-choice-info">
              Complete platform governance, administrative users, financial wallets, members & operations oversight.
            </p> */}

            {/* <div className="portal-choice-tags">
              <span className="portal-tag">Platform Control</span>
              <span className="portal-tag">Wallets</span>
              <span className="portal-tag">Members</span>
            </div> */}

            <button
              type="button"
              className="portal-choice-btn btn-superadmin"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/superadmin/login");
              }}
            >
              <span>Sign In as Super Admin</span>
              <FaArrowRight className="btn-arrow" size={13} />
            </button>
          </div>

          {/* Option 2: IT */}
          <div
            className="portal-choice-card card-it"
            onClick={() => navigate("/it/login")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/it/login")}
          >
            <div className="portal-choice-header">
              <span className="portal-choice-badge badge-it">IT Management</span>
            </div>

            <div className="portal-choice-icon-wrap icon-it">
              <MdOutlineAdminPanelSettings size={36} />
            </div>

            <h3 className="portal-choice-name">IT Administration</h3>
            {/* <p className="portal-choice-info">
              IT management, infrastructure diagnostics, system security, server diagnostics & portal access privileges.
            </p> */}

            {/* <div className="portal-choice-tags">
              <span className="portal-tag">Infrastructure</span>
              <span className="portal-tag">Security</span>
              <span className="portal-tag">System Logs</span>
            </div> */}

            <button
              type="button"
              className="portal-choice-btn btn-it"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/it/login");
              }}
            >
              <span>Sign In as IT</span>
              <FaArrowRight className="btn-arrow" size={13} />
            </button>
          </div>
        </div>

        <div className="portal-security-footer">
          <FaShieldAlt className="security-icon" size={14} />
          <span>Protected by TopCoin UK multi-factor 2FA security and end-to-end encryption</span>
        </div>
      </div>
    </div>
  );
}
